/* 🤖 this file was generated by script */
export const wiconInfoCircle = {
  name: 'info_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 16v-4m0-4h.01M22 12a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
